module.exports = __webpack_public_path__ + "static/media/data-hero1-v2.486bb879.png";